(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GroupResponse',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$('.reject').click(function rejectIt() {
			$('#groupresponse-action').val('Rejected');
			$('#form-respond').submit();
		});

		$('.approve').click(function rejectIt() {
			$('#groupresponse-action').val('Approved');
		});

		$('.comment').click(function rejectIt() {
			$('#groupresponse-action').val('Commented On');
		});
	};

}(jQuery, window.Adzuki || {}));
